import { HTMLAttributes, ReactNode } from "react";
import s from "./style.module.scss";
import clsx from "clsx";

interface BlockProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  className?: string;
  borderRadius?: "top" | "bottom" | "all" | "none";
  wihoutPadding?: boolean;
}

export const Block = (props: BlockProps) => {
  const {
    children,
    className,
    borderRadius = "all",
    wihoutPadding,
    ...other
  } = props;
  return (
    <div
      className={clsx(
        s.block,
        className,
        s[borderRadius],
        wihoutPadding && s.wihoutPadding
      )}
      {...other}
    >
      {children}
    </div>
  );
};
